import React, { useEffect } from "react"
import Safe from "react-safe"

const postman = () => {
	const script = document.createElement("script");

    script.src = "https://run.pstmn.io/button.js";
    script.async = true;
		script.id = "_pmPostmanRunObject"

    document.body.appendChild(script);
}


const Postman = () => {
	
	useEffect(() => {
		postman()
	},[])

	return (
		<>
		<div className="postman-run-button" data-postman-action="collection/import" data-postman-var-1="e3ad8fdbe55fb1c62766" data-postman-param="env%5BVoxology%20REST%20API%5D=W3sidHlwZSI6InRleHQiLCJlbmFibGVkIjp0cnVlLCJrZXkiOiJCQVNFX1VSTCIsInZhbHVlIjoiYXBpLnZveG9sby5neS92MSIsImRlc2NyaXB0aW9uIjoiIn0seyJ0eXBlIjoidGV4dCIsImVuYWJsZWQiOnRydWUsImtleSI6IkJBU0lDX0FVVEgiLCJ2YWx1ZSI6IllPVVJfQVVUSF9LRVkiLCJkZXNjcmlwdGlvbiI6IiJ9LHsidHlwZSI6InRleHQiLCJlbmFibGVkIjp0cnVlLCJrZXkiOiJYX0FQSV9LRVkiLCJ2YWx1ZSI6IllPVVJfQVBJX0tFWSIsImRlc2NyaXB0aW9uIjoiIn1d" data-postman-button-index="0"></div>
		</>
	)
	
}
export default Postman